import React, { useState } from "react";
import HeroImage from "../../assets/img/portfolio/Diksha&Ram/Diksha&RamBigBanner.webp";

import gallery from "../../assets/img/bg/weiding-bg.webp";

const DikshaRam = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // Define your image paths here
  const images = {
    portfolio1: require("../../assets/img/portfolio/Diksha&Ram/1.webp"),
    portfolio2: require("../../assets/img/portfolio/Diksha&Ram/2.webp"),
    portfolio3: require("../../assets/img/portfolio/Diksha&Ram/3.webp"),
    portfolio4: require("../../assets/img/portfolio/Diksha&Ram/4.webp"),
    portfolio5: require("../../assets/img/portfolio/Diksha&Ram/5.webp"),
    portfolio6: require("../../assets/img/portfolio/Diksha&Ram/6.webp"),
    portfolio7: require("../../assets/img/portfolio/Diksha&Ram/7.webp"),
    portfolio8: require("../../assets/img/portfolio/Diksha&Ram/8.webp"),
    portfolio9: require("../../assets/img/portfolio/Diksha&Ram/9.webp"),
    portfolio10: require("../../assets/img/portfolio/Diksha&Ram/10.webp"),
    portfolio11: require("../../assets/img/portfolio/Diksha&Ram/11.webp"),
    portfolio12: require("../../assets/img/portfolio/Diksha&Ram/12.webp"),
    portfolio13: require("../../assets/img/portfolio/Diksha&Ram/13.webp"),
    portfolio14: require("../../assets/img/portfolio/Diksha&Ram/14.webp"),
    portfolio15: require("../../assets/img/portfolio/Diksha&Ram/15.webp"),
    portfolio16: require("../../assets/img/portfolio/Diksha&Ram/16.webp"),
  };

  // Function to handle image click: opens the modal with the selected image
  const openModal = (imageKey) => {
    setSelectedImage(images[imageKey]);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const containerStyle = {
    background: `url(${HeroImage}) center/cover no-repeat`,
    backgroundColor: "#1C242970", // This sets a semi-transparent overlay color
    height: "60vh",
  };

  return (
    <div>
      <div
        style={containerStyle}
        className="flex  items-center justify-center relative -z-[900]"
      >
        <div className="absolute inset-0 bg-[#0000007f] z-0"></div>

        <h2 className="text-white text-center text-[60px] z-0">Diksha & Ram</h2>
      </div>

      <div class="flex flex-col lg:flex-row justify-center gap-10 lg:px-10 px-2 py-10">
        <div class="lg:w-[500px]">
          <div class="lv-portfolio-details-top-wrap-1-4 mb-35">
            <h4 class="lv-portfolio-details-title-1-4 text-[#000066]">
              Diksha & Ram
            </h4>

            <span class="lv-portfolio-date-1-4">
              November 2024, Goa Marriott resort & spa, Goa
            </span>
          </div>
          <div class="lv-portfolio-details-content-1-4 mb-30">
            <h2>A Punjabi-Tamil Wedding in the Heart of Goa</h2>
            <p class="mb-25">
              When Diksha & Ram came to us, they wanted their wedding to be a
              seamless blend of their Punjabi and Tamil cultures. With Diksha
              from Mumbai and Ram from Sri Lanka, their vision was to create a
              celebration that honored their roots while embracing the vibrant
              energy of Goa. From the Mehendi & Haldi to the Sangeet and the
              traditional Tamil wedding, every event was designed to reflect
              their unique love story.
            </p>
            <h3>A Joyous Mehendi & Haldi Celebration</h3>
            <p class="mb-25">
              We kicked off the wedding festivities with a colorful Mehendi &
              Haldi at Goa Marriott Resort & Spa. The space came alive with
              floral installations in shades of orange, pink, and purple, while
              pastel fabric frills draped the ceilings, adding a breezy charm.
              Comfortable diwans and khaats created a cozy vibe for guests to
              relax and enjoy the celebrations, complete with fun activity
              stations and a stunning photobooth.
            </p>
            <h3>A Glamorous Sangeet Night</h3>
            <p class="mb-25">
              For the Sangeet, we transformed the space into a dazzling setup
              featuring mirror danglers, LED butterflies, and a shimmering rice
              light cove above the dance floor. The focal point? A spectacular
              LED-backdrop bar that added the perfect touch of glamour. With
              luxurious midnight blue sequined table overlays and stylish ghost
              chairs, the evening was a beautiful mix of elegance and high
              energy.
            </p>
            <h3>A Traditional Yet Breathtaking Tamil Wedding</h3>
            <p class="mb-25">
              Diksha & Ram’s wedding was steeped in tradition, with a stunning
              mandap adorned with lotus installations and a floral-laden aisle
              leading to it. The ceremony was deeply rooted in Tamil customs,
              and every element, from the cross-back chairs for seating to the
              petal shower giveaways, was carefully planned to enhance the
              experience. A regal sit-down imperial lunch followed, bringing
              family and friends together in a beautiful, intimate setting.
            </p>
            <h3>A Sundowner to Remember</h3>
            <p class="mb-25">
              To wrap up this incredible wedding, we curated a laid-back yet
              elegant sundowner by the beach, where guests could unwind, soak in
              the Goan breeze, and celebrate the couple’s new journey.
            </p>
            <h3>A Love Story We Loved Bringing to Life</h3>
            <p class="mb-25">
              Every wedding we plan is special, but Diksha & Ram’s celebration
              was a heartwarming blend of tradition, modern elegance, and
              meaningful moments. From the smallest décor detail to the grandest
              celebration, we were honored to bring their vision to life and
              create a wedding they will cherish forever.
            </p>
          </div>
        </div>

        <div className="lg:w-[600px]">
          {/* Mapping other images, assuming similar behavior for simplicity */}
          <div className="py-3">
            <img
              className=""
              src={require("../../assets/img/portfolio/Diksha&Ram/16.webp")}
            />
          </div>
          <div className="flex gap-3 flex-col lg:flex-row ">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio1"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio2"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio3"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio4"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio5"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio6"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio7"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio8"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-no-repeat  bg-right-top"
              style={{
                backgroundImage: `url(${images["portfolio9"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio10"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio11"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio12"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio13"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio14"]})`,
              }}
            ></div>
          </div>
          <div className="flex gap-3 flex-col lg:flex-row  py-3">
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-center"
              style={{
                backgroundImage: `url(${images["portfolio15"]})`,
              }}
            ></div>
            <div
              className="lg:w-[400px] h-[300px] bg-cover bg-top-center"
              style={{
                backgroundImage: `url(${images["portfolio16"]})`,
              }}
            ></div>
          </div>

          {/* Modal for displaying the clicked image */}
          {isModalOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
              onClick={closeModal}
            >
              <img
                src={selectedImage}
                alt="Modal"
                style={{ maxWidth: "90%", maxHeight: "90%" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DikshaRam;
